import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=53db3b98&scoped=true"
import script from "./userList.vue?vue&type=script&lang=ts"
export * from "./userList.vue?vue&type=script&lang=ts"
import style0 from "./userList.vue?vue&type=style&index=0&id=53db3b98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53db3b98",
  null
  
)

export default component.exports